import angular from 'angular';

angular
  .module('dashboard')

  .controller('MessageDetailsCtrl', [
    '$scope',
    '$uibModal',
    'MessageService',
    'message',
    '$state',
    'API_CONFIG',
    function($scope, $uibModal, MessageService, message, $state, API_CONFIG) {
      $scope.message = message;

      $scope.back = function() {
        $state.go('messages', { keepFilter: true });
      };

      // Affichage du message au format XML
      $scope.openXmlMessage = function(messageId) {
        return MessageService.getXmlMessage(messageId);
      };

      $scope.downloadZipUrl = function(messageId) {
        return API_CONFIG.url + '/v1/message/' + messageId + '/zip';
      };
    }
  ]);
